import React, { useEffect, useRef } from "react";
import { StaticToolbar } from "./basic/Toolbar";
import { CodeEditor } from "./CodeEditor";
import { Size } from "models";
import { DispatchContext } from "../store";
import { isIE } from "../utils/isIE";
import { Toolbar } from "dhx-suite";

interface HtmlCodePanelProps {
  codeValue: string;
  onChange: (calue: string) => void;
  toolbarClick?: (id: string) => void;
  size?: Size;
  isSaved: boolean;
  isDarkMode: boolean;
  collapsable?: boolean;
  collapse?: boolean;
}

const TOOLBAR_HEIGHT = 43;

export const HtmlCodePanel = ({
  codeValue,
  onChange,
  size,
  isSaved,
  isDarkMode,
  collapsable,
  collapse,
  toolbarClick,
}: HtmlCodePanelProps) => {
  const { dispatch } = React.useContext(DispatchContext);
  const ref = useRef<HTMLDivElement>(null);
  const [toolbar, setToolbar] = React.useState<Toolbar>();

  useEffect(() => {
    if (ref.current) {
      const container = ref.current.parentNode as HTMLDivElement;
      window.addEventListener("resize", () => {
        dispatch({
          type: "HtmlPanelResized",
          size: {
            height: container.clientHeight,
            width: container.clientWidth,
          },
        });
      });
      dispatch({
        type: "HtmlPanelResized",
        size: { height: container.clientHeight, width: container.clientWidth },
      });
    }
  }, []);

  useEffect(() => {
    if (collapsable && toolbar && !toolbar.data.exists("collapse")) {
      toolbar.data.add(
        {
          color: "secondary",
          type: "button",
          circle: true,
          css: "toggle",
          view: "link",
          icon: `mdi mdi-chevron-down`,
          id: "collapse",
        },
        0
      );
    }
  }, [collapsable, toolbar]);

  useEffect(() => {
    if (toolbar && collapsable) {
      if (collapsable) {
        toolbar.data.update("collapse", {
          icon: `mdi mdi-chevron-${collapse ? "down" : "up"}`,
          id: "collapse",
        });
      }
    }
  }, [toolbar, collapse]);

  return (
    <div className="st-js-pane" ref={ref}>
      <StaticToolbar
        controls={[{ type: "title", value: "HTML", css: "title" }]}
        onToolbarMounted={setToolbar}
        onClick={(id: string) => {
          if (id === "collapse" && toolbarClick) {
            toolbarClick(id);
          }
        }}
        className={`st-code-pane--toolbar${isSaved ? "" : " not-saved"}`}
      />
      <CodeEditor
        mode="html"
        value={codeValue}
        onChange={onChange}
        size={
          size ? { ...size, height: size.height - TOOLBAR_HEIGHT } : undefined
        }
        isDarkMode={isDarkMode}
        type={isIE ? "codeMirror" : "monaco"}
      />
    </div>
  );
};
